import map from 'lodash/map'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { BoardCheckbox, CreateNewBoardButton, SaveCancelBoardItemButton, useContext } from '@ztechapps/board.webui'

export const AddItemModalContent = () => {
  const { selectedBoard } = useContext()

  return (
    <div className="flex-column d-flex justify-content-between   h-100 ">
      <div>
        <h3 className="text-center  ">Save to your favorites and stay organized!</h3>
        <div className="small text-center">Choose which favorites you want to add this item</div>
        <hr />
        <Row>
          {map(selectedBoard, (item) => (
            <Col lg={6} key={item?._id}>
              <BoardCheckbox {...item} />
            </Col>
          ))}
        </Row>
      </div>
      <div>
        <hr />
        <div className="d-flex justify-content-between   mt-4 ">
          <CreateNewBoardButton text="Create new favorite" />
          <SaveCancelBoardItemButton />
        </div>
      </div>
    </div>
  )
}
